import { fetchCustomer } from '../services/UserService';

export const prefillData = async (dependencie) => {
  const {
    prefillingData,
    searchParams,
    setCustomer,
    reset,
    setPensionFee,
    setPensionAmount,
    setHolidaySavingFee,
    setInitialInvoiceHours,
    setPreviousSelectedFreelancers,
    setSelectedList,
    setDates,
    setShow,
    setOtherArticlesData,
    invoiceCreatedUserId,
    selectRef,
    ARTICLE_NUMBERS,
    NEW_ARTICLES,
    userID,
    setLoading
  } = dependencie;
// let UserIds = prefillingData?.user?.userId || userID;
  if (
    prefillingData?.getInvoiceData &&
    Object.keys(prefillingData?.getInvoiceData)?.length > 0 &&
    searchParams?.size >= 1
  ) {
    // const userDetails = await fetchCustomer(UserIds, {
    const userDetails = await fetchCustomer(userID, {
      setLoading,
      setCustomers: setCustomer,
      setFreelancers: setPreviousSelectedFreelancers,
      setUserDetails: setCustomer,
    });

    const {
      invoiceHours,
      description,
      selectedCustomer,
      freelancer,
      showDates,
      file,
      isFixed,
      vat,
      amount,
      otherArticles,
    } = prefillingData?.getInvoiceData;

    setCustomer({
      ...selectedCustomer,
      customerId: selectedCustomer?.customerId,
    });

    const selectedFreelancers = freelancer?.map((item) => ({
      ...item,
      value: item.userId,
    }));

    reset({
      vat,
      amount,
      isFixed,
      description,
      selectedCustomer,
      invoiceFile: prefillingData?.getInvoiceData?.fetchInvoices?.file
        ? prefillingData?.getInvoiceData?.fetchInvoices?.file
        : file,
      freelancer: selectedFreelancers,
      showDates: showDates && JSON.stringify(JSON.parse(showDates)),
      invoiceHours: invoiceHours && JSON.parse(JSON.stringify(invoiceHours)),
      rootDeduction: prefillingData?.getInvoiceData?.fetchInvoices?.rootDeduction,
      house: prefillingData?.getInvoiceData?.fetchInvoices?.house,
      apartment: prefillingData?.getInvoiceData?.fetchInvoices?.apartment,
      rotApartmentNo: prefillingData?.getInvoiceData?.fetchInvoices?.rotApartmentNo,
      brfNo: prefillingData?.getInvoiceData?.fetchInvoices?.brfNo,
      rutDeduction: prefillingData?.getInvoiceData?.fetchInvoices?.rutDeduction,
      pension: prefillingData?.getInvoiceData?.fetchInvoices?.pension,
      holidaySavings: prefillingData?.getInvoiceData?.fetchInvoices?.holidaySavings,
      expressPayout: prefillingData?.getInvoiceData?.fetchInvoices?.expressPayout,
      currency: prefillingData?.getInvoiceData?.fetchInvoices?.currency,
    });

    setPensionFee(prefillingData?.getInvoiceData?.fetchInvoices?.pensionFee);
    setPensionAmount(prefillingData?.getInvoiceData?.fetchInvoices?.pensionAmount);
    setHolidaySavingFee(prefillingData?.getInvoiceData?.fetchInvoices?.holidaySavingsFee);

    let allSelectedDates = {};

    if (Array.isArray(invoiceHours) && invoiceHours[0] !== undefined) {
      invoiceHours?.forEach((item, index) => {
        Object.keys(item)?.forEach((date) => {
          const splitDate = date?.split('-');
          const fullDate = `${splitDate[0]}-${splitDate[1]}-${splitDate[2]}`;
          const uuid = splitDate?.slice(3).join('-');
          if (uuid) {
            const newDate = new Date(fullDate);
            const previousDates = allSelectedDates[index];
            allSelectedDates = {
              ...allSelectedDates,
              [index]: previousDates
                ? [
                    ...previousDates,
                    {
                      date: newDate,
                      id: uuid,
                    },
                  ]
                : [
                    {
                      date: newDate,
                      id: uuid,
                    },
                  ],
            };
          } else {
            const newDate = new Date(date);
            const previousDates = allSelectedDates[index];
            allSelectedDates = {
              ...allSelectedDates,
              [index]: previousDates
                ? [
                    ...previousDates,
                    {
                      date: newDate,
                    },
                  ]
                : [
                    {
                      date: newDate,
                    },
                  ],
            };
          }
        });
      });
    }

    setInitialInvoiceHours(JSON.parse(JSON.stringify(invoiceHours)));
    setPreviousSelectedFreelancers(selectedFreelancers);

    const { createdBy, userId, createdDate, isDeleted, updatedDate } = userDetails;
    const selectedList = freelancer?.length === 0 ? [
      {
        userId,
        createdBy,
        createdDate,
        isDeleted,
        updatedDate,
        value: userId,
        signUpUser: { ...userDetails },
      },
    ] : [];

    if (freelancer?.length > 0) {
      selectedList.push(...freelancer);
    }

    setSelectedList(selectedList);
    setDates((prevState) => ({ ...prevState, ...allSelectedDates }));
    setShow((prevState) => ({ ...prevState, showFreelancerSelect: true }));

    setOtherArticlesData((prevData) => {
      const updatedData = { ...prevData };

      otherArticles?.forEach((item) => {
        let indexToUpdate = -1;
        if (item.userId === invoiceCreatedUserId) {
          indexToUpdate = 0;
        } else {
          const freelancerIndex = selectedFreelancers?.findIndex(
            (freelancer) => freelancer?.userId === item?.userId
          );
          if (freelancerIndex !== -1) {
            indexToUpdate = freelancerIndex + 1;
          }
        }

        if (indexToUpdate !== -1 && indexToUpdate <= 15) {
          const existingIndex = updatedData[indexToUpdate]?.findIndex(
            (existingItem) =>
              existingItem.value === item.value &&
              existingItem.userId === item.userId &&
              existingItem.key === item.key
          );

          if (existingIndex === -1) {
            if (!updatedData[indexToUpdate]) {
              updatedData[indexToUpdate] = [];
            }
            updatedData[indexToUpdate].push({
              id: item?.dateId,
              value: item?.amountInSek,
              valueInSelectedCurrency: item?.amount,
              userId: item.userId,
              key:
                item.articleNumber === ARTICLE_NUMBERS.TRAVEL
                  ? NEW_ARTICLES.TRAVEL
                  : item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
                    item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX || item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
                  ? NEW_ARTICLES.MATERIAL_VAT
                  : item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
                    item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
                    item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
                    item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY
                  ? NEW_ARTICLES.ALLOWANCE_IN
                  : item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
                    item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX
                  ? NEW_ARTICLES.ALLOWANCE_OUT
                  : item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
                    item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX
                  ? NEW_ARTICLES.MILEAGE
                  : '',
              label: item?.workingDescription,
              data: item,
            });
          }
        }
      });

      return updatedData;
    });
  } else {
    selectRef?.current?.focus();
  }
};